import type { View } from "@gooner/shared";
import { MONITOR_TEMPLATES } from "@gooner/shared";
import { QuickSetupCard } from "./QuickSetupCard";
import { CollectionGrid } from "../collections/CollectionCard";
import type { CollectionOption } from "../lib/monitorTemplates";

/**
 * The built-ins, below Your views, each drawn with its real geometry.
 *
 * They sit in the same grid, wearing the same shell, under the same rule as a view card:
 * clicking plays it, hovering reveals the one deliberate thing you do to it. That is on
 * purpose — one grammar, learned once, so the section below the fold needs no separate
 * explanation.
 */
export function QuickSetups({
  collections,
  onCopied,
  onError,
}: {
  collections: CollectionOption[];
  onCopied: (view: View) => void;
  onError: (message: string) => void;
}) {
  return (
    <section className="mt-10">
      <h2 className="mb-1 text-xs font-semibold uppercase tracking-wide text-zinc-400">
        Quick setups
      </h2>
      <p className="mb-3 max-w-prose text-sm text-zinc-500">
        Click one to put it on a screen now — nothing is saved. Copy it to keep it in your
        views and change it later.
      </p>
      <CollectionGrid>
        {MONITOR_TEMPLATES.map((t) => (
          <QuickSetupCard
            key={t.id}
            template={t}
            collections={collections}
            onCopied={onCopied}
            onError={onError}
          />
        ))}
      </CollectionGrid>
    </section>
  );
}
